import axios from "axios";
import { CustomerDetailsResponse } from "redmond";

import { customerDetailsApiPath } from "../paths";
import { config } from "../../config";

export const fetchCustomerDetails = (): Promise<CustomerDetailsResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get(customerDetailsApiPath, {
        baseURL: config.baseURL,
      });

      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });
